<template>
  <template v-if="step === 3 && ! hasConcessionInCart() && hasSponsoredConcessions()">
    <Carousel v-bind="carouselConfig">
      <Slide v-for="(item, i) in concessions" :key="i">
        <div class="card mr-3" v-if="item.sponsored && !isConcessionInCart(item)">
          <div class="card-body">
            <div class="row align-items-center mb-2">
              <div class="col">
                <h4 class="mb-1">
                  {{ item.name }}
                </h4>
                <p
                    class="card-text small text-muted"
                    v-if="item.description !== item.name"
                >
                  {{ item.description }}
                </p>
              </div>
              <div class="col-auto">
                <span class="text-danger">
                  {{ useFormatting().formatCurrency(item.price) }}
                </span>
                <span v-if="item.discount > 0" class="badge badge-danger d-block">-{{ useFormatting().formatCurrency(item.discount) }}</span>
              </div>
            </div>

            <a href="#"
               class="btn btn-outline-dark d-block"
               @click.prevent="addConcession(item)"
            >Thêm combo này</a>
          </div>
        </div>
      </Slide>
    </Carousel>
  </template>
</template>

<script setup>
import { Carousel, Slide } from 'vue3-carousel'
import { useFormatting } from '../composables/formatting';
import MobileDetect from 'mobile-detect';

import 'vue3-carousel/carousel.css'

const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  cart: {
    type: Object,
    required: true
  },
  concessions: {
    type: Array,
    required: true
  }
})

const emit = defineEmits([
  'update:concession'
])

const hasSponsoredConcessions = () => {
  return props.concessions.some(concession => concession.sponsored);
}

const hasConcessionInCart = () => {
  return props.cart.concessions.length > 0;
}

const isConcessionInCart = (item) => {
  return props.cart.concessions.some(concession => concession.id === item.id);
}

const getConcession = (item) => {
  return props.concessions.find(concession => concession.id === item.id);
}

const md = new MobileDetect(window.navigator.userAgent);
let carouselConfigEnabled = false
if (md.mobile() && !md.tablet()) {
  carouselConfigEnabled = true
}

const carouselConfig = {
  enabled: carouselConfigEnabled,
  itemsToShow: 'auto',
  wrapAround: false,
  snapAlign: 'start',
  gap: 0
}

const addConcession = (promotionConcession) => {
  const concession = getConcession(promotionConcession);
  emit('update:concession', { concession, action: 'add' })
}
</script>

<style>

</style>